import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeinformationComponent } from '../homeinformation/homeinformation.component';



@NgModule({
  declarations: [HomeinformationComponent],
  exports: [HomeinformationComponent],
  imports: [
    CommonModule
  ]
})
export class SharedHomeinformationModule { }
